import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function ButternutSquashPasta() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Butternut Squash Pasta</Typography>
      <Typography variant="h3">Ingredients</Typography>
      <Typography>
        ½ butternut squash<br></br>1 Tbsp (15 mL) olive oil<br></br>⅛ tsp salt
        <br></br>1 pinch ground black pepper<br></br>1 head garlic<br></br>
        <b>Pasta</b>
        <br></br>
        14 oz (400 g) dry rigatoni<br></br>1 Tbsp (15 mL) olive oil<br></br>½
        cup (23 g) sage leaves, sliced<br></br>1 cup (240 mL) soy cooking cream
        <br></br>½ lemon, juiced<br></br>1 cup (20 g) arugula<br></br>
      </Typography>
      <Typography>
        Preheat oven to 390°F (200°C) and line a baking tray. <br></br>
        Carefully peel the outer skin of the squash, or keep it on for extra
        fibre. <br></br>
        Cut the butternut squash in half lengthwise. <br></br>
        Use a spoon to scrape out the seeds and stringy bits and place these
        into a bowl of water.<br></br>
        <br></br>
        Thinly slice the squash into ½ cm thick slices. <br></br>
        Transfer to the baking tray, toss in oil, and sprinkle on some salt and
        pepper.<br></br>
        <br></br>
        Cut the top ½ cm off a head of garlic to expose the cloves. <br></br>
        Drizzle some oil on the garlic and place this on the baking tray as
        well. <br></br>
        Bake the garlic and squash for 20 minutes.<br></br>
        <br></br>
        Returning to the seeds in water, gently pick out the seeds and discard
        the stringy bits. <br></br>
        Then drain and rinse the seeds until clean. <br></br>
        Toss the seeds in a bit of oil, together with a sprinkle of salt and
        pepper to taste.<br></br>
        <br></br>
        Remove the baking tray from the oven. <br></br>
        Remove the head of garlic from the tray, and add in its place the squash
        seeds. <br></br>
        Flip over the squash slices and return to the ovenfor another 10 - 15
        minutes, or until the seeds are lightly golden, and the squash is
        thoroughly cooked.<br></br>
        <br></br>
        Cook the pasta in a large pot of boiling salted water. <br></br>
        Cook until tender but not quite done - about 1 minute away from being al
        dente.<br></br>
        <br></br>
        Meanwhile, heat a large pan on medium-high heat and add the oil and
        sage. <br></br>
        Cook for 1 - 2 minutes, or until the sage shrivels. Add in the roasted
        garlic cloves, and mash with the back of a wooden spatula to purée it.
        <br></br>
        <br></br>
        Scoop out ¾ cup (180 mL) of the pasta cooking water and add it to the
        pan. <br></br>
        Then drain the pasta, and add this to the pan as well, along with the
        cooking cream. <br></br>
        Cook for a minute until heated through.<br></br>
        <br></br>
        Stir through the lemon juice, and plate while hot. <br></br>
        Top with arugula, baked squash, and crispy squash seeds. Enjoy!<br></br>
      </Typography>
    </Card>
  );
}
